import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './cashlesssociety.json';

const Cashlesssociety = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Practice English with exercises on digital payments, cryptocurrency, and the future of money. Grammar, vocabulary, reading, and discussion activities for B2 level."
            level="B2"
            title="Cashless Society"
            image="/Images/cashless.webp"
            seoTitle="Free English Lesson Plans: Cashless Society"
            seoDescription="Practice English with exercises on digital payments, cryptocurrency, and the future of money. Grammar, vocabulary, reading, and discussion activities for B2 level."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Cashlesssociety;


